<template>
  <div class="">
    <button class="btn-indigo w-32 font-normal" @click="openModal()">Processor</button>
    <ModalHeadlessUI ref="modal">
      <template #default>
        <h1 class="font-bold mb-4 text-3xl text-center">
          Assign Processor
        </h1>
        <form id="processorForm" name="processorForm" @submit.prevent="assignProcessor">
          <select-input v-if="auth.user.owner" v-model="processorForm.processor" :error="processorForm.errors.processor" class="pr-6 pb-4 w-full" label="Select Processor (Leave Blank for Auto Assignment)" @change="update">
            <option :value="null" />
            <option v-for="user in processors" :key="user.id" :value="user.id">{{ user.first_name }} {{ user.last_name }}</option>
          </select-input>
          <label class="form-label">Assignment Details:</label>
          <EmailEditor v-model="processorForm.emailMessageModal" :error="processorForm.errors.emailMessageModal" />
          <div v-if="processorForm.errors.emailMessageModal" class="form-error">{{ processorForm.errors.emailMessageModal }}</div>
          <div class="flex justify-center items-center mt-5">
            <div>
              <loading-button :loading="processorForm.processing" class="btn-indigo ml-auto" type="submit">Assign Processor</loading-button>
            </div>
          </div>
        </form>
      </template>
    </ModalHeadlessUI>
  </div>
</template>

<script>
import ModalHeadlessUI from '@/Shared/ModalHeadlessUI'
import EmailEditor from '@/Shared/EmailEditor'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import { router } from '@inertiajs/vue3'

export default {
  components: {
    ModalHeadlessUI,
    EmailEditor,
    SelectInput,
    LoadingButton,
  },
  props: {
    lead:{
      type: Object,
      default: null,
    },
    auth:{
      type: Object,
      default: null,
    },
    processors:{
      type: Object,
      default: null,
    },
  },
  emits: ['processorAssigned'],
  data() {
    return {
      processorForm: router.form({
        id: this.lead.id,
        emailMessageModal: '<p><strong>Lender </strong>-</p><p><strong>Loan Type</strong> - &nbsp;</p><p><strong>Term </strong>-</p><p><strong>Property Type </strong>-</p><p><strong>Title Company and Contact Info</strong> -</p><p><strong>Realtor Contact Info (Both Agents if Available)</strong> -</p><p><strong>App Sent and Signed? </strong>-&nbsp;</p><p><strong>Floify Acct Started?</strong> -&nbsp;</p><p><strong>Any docs waiting on?</strong> -&nbsp;</p><p><strong>Reviewed Docs and Job History? </strong>-&nbsp;</p><p><strong>Should we order the appraisal right away?</strong> -&nbsp;</p><p><strong>What is the source of the down payment?</strong> -&nbsp;</p><p><strong>What is the preferred contact method (Text, Email, Phone)?</strong> -&nbsp;</p><p><strong>Should we wait for full submission?</strong> -&nbsp;</p><p><strong>Important Notes</strong> -&nbsp;</p>',
        processor: '',
      }),
    }
  },
  computed:{
  },
  methods:{
    openModal() {
      this.$refs.modal.openModal()
    },
    closeModal() {
      this.$refs.modal.closeModal()
    },
    assignProcessor() {
      this.$emit('processorAssigned', this.processorForm.processor, this.processorForm.emailMessageModal)
      this.processorForm.reset('emailMessageModal')
      this.closeModal()
    },
  },
}
</script>
